import React from "react";
import {getBarcodeFromBase64} from "../utils/barcode";

export default function GenericTicketCard({data, barcodeImage}) {
    return (
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="p-4">
                <div className="flex items-center">
                    <img
                        src={data.logo}
                        alt="Event logo"
                        className="w-14 h-14 rounded-xl bg-gray-100"
                    />
                    <div className="ml-4 flex-1">
                        <h2 className="text-lg font-bold text-gray-900 mb-1">
                            {data.title}
                        </h2>
                    </div>
                </div>
            </div>

            <div className="h-px bg-gray-200 mx-4" />

            <div className="p-4">
                <div className="flex mb-2">
          <span className="w-20 text-sm text-gray-500 font-medium">
            Venue
          </span>
                    <span className="flex-1 text-sm text-gray-700 font-medium">
            {data.venue_name}
          </span>
                </div>
                <div className="flex mb-2">
                    <span className="w-20 text-sm text-gray-500 font-medium">Seat</span>
                    <span className="flex-1 text-sm text-gray-700 font-medium">
            {data.seat.seat_info_combined}
          </span>
                </div>
                <div className="flex mb-2">
                    <span className="w-20 text-sm text-gray-500 font-medium">Date</span>
                    <span className="flex-1 text-sm text-gray-500">
            {data.subtitle}
          </span>
                </div>
            </div>

            <div className="border-t border-gray-200 p-4">
                <div className="flex justify-center relative">
                    <img
                        src={barcodeImage ? `data:image/png;base64,${barcodeImage}` : ''}
                        alt="Ticket QR Code"
                        className="relative z-10"
                    />
                </div>
                <p className="text-center text-sm text-gray-500 mt-2">
                    Ticket ID: {data.id}
                </p>
            </div>

            <div className="bg-gray-50 p-3 border-t border-gray-200">
                <div className="flex items-center justify-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-green-500" />
                    <p className="text-sm text-gray-500">
                        Barcode may change often for security. Do not screenshot.
                    </p>
                </div>
            </div>
        </div>
    );
}
